import { render, staticRenderFns } from "./ActivityTimeLineItemImage.vue?vue&type=template&id=5f188677&"
import script from "./ActivityTimeLineItemImage.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VList,VSkeletonLoader})
